<template>
    <div class="page-container">
        <!-- 顶部导航 -->
        <nav-bar ref="navBar" :maxOpacity="0.5" bgColor="#000" @watchScroll="watchScroll">
            <div class="nav-box">
                <img class="back" :src="backUrl" @click="goBack">
                <div :style="{color:fontColor}">规则说明</div>
                <div class="back"></div>
            </div>
        </nav-bar>
        <div class="rule-page-content" :style="`margin-top:calc(10.333vw + ${statusBarHeight}px)`">
            <p v-for="(item,index) in rule" :key="index">{{ item }}</p>
        </div>
    </div>
</template>

<script>
import navBar from './components/NavBar.vue'
import whiteBack from '../../assets/images/postalNewCustomer/back.png'
import blackBack from '../../assets/images/postalNewCustomer/back_black.png'
export default {
    components: { navBar },
    data() {
        return {
            rule: [
                '1、用户首日最多可获得6次抽奖机会，每日抽奖任务（精力值兑换任务、邀请好友任务）于次日0点重置。',
                '2、抽奖次数兑换规则：',
                '2000kcal精力值可兑换一次抽奖机会。（每日限一次）。',
                '邀请未注册青碳行App用户参与一次抽奖活动可以兑换一次抽奖机会（每日限三次）。',
                '用户报名参与活动可获得一次抽奖机会。（限一次）。',
                '授权成功低碳有礼，即可获得一次抽奖机会（限一次）。',
                '3、用户获得的实物奖品，需联系客服到线下指定地点领取，青碳行客服微信：lcago0628；青碳行官方客服电话：0532-55772222。',
                '4、参与转盘获得奖励的使用规则，可在“我的奖励-使用规则”中查看。',
                '5、本活动与APPLEINC无关。'
            ],
            fontColor: '#000',
            backUrl: blackBack
        }
    },
    computed: {
        statusBarHeight() {
            return this.$store.state.user.statusBarHeight
        },
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        watchScroll(scroll) {
            if (scroll <= 10) {
                this.fontColor = '#000'
                this.backUrl = blackBack
            } else {
                this.fontColor = '#fff'
                this.backUrl = whiteBack
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import "./components/common";
@import "./components/function.scss";
.nav-box {
    width: 100vw;
    padding: 0 pxvw(30);
    display: flex;
    align-items: center;
    justify-content: space-between;
    // color: #fff;
    font-size: pxvw(32);
    height: 10.333vw;
    .back {
        width: pxvw(34);
        height: pxvw(34);
    }
}
.page-container {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;

    .rule-page-content {
        padding: pxvw(32) pxvw(40) pxvw(60);

        h2 {
            text-align: center;
            margin: px2rem(40) auto 0;
        }

        h3 {
            text-align: left;
            margin-top: px2rem(40);
            margin-bottom: px2rem(20);
        }

        p {
            margin-bottom: px2rem(20);
            font-size: 16px;
            letter-spacing: 1.5px;
            line-height: 1.5;
            text-align: justify;
            word-break: break-all;

            span {
                color: #1db9b2 !important;
            }
        }
    }
}
</style>
